import './CurrentUserAvatar.scss';
import React from 'react';
import { SonarUser } from '@ui/SonarUser';
import { useCurrentUser } from '@hooks';
export const CurrentUserAvatar = (props) => {
    const user = useCurrentUser();
    if (!user) {
        return null;
    }
    return React.createElement(SonarUser, Object.assign({}, props, { className: 'current-user-avatar', userId: user.id, withFullName: false }));
};
